import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { IState } from '../types';
import { navigationReducer } from './navigation.slice';
import { settingsReducer } from './settings.slice';
import { userReducer } from './user.slice';

export const rootReducer = combineReducers<IState>({
  navigation: navigationReducer,
  settings: settingsReducer,
  user: userReducer,
});

export const store = configureStore({ reducer: rootReducer });
